import { CheckIcon } from "@heroicons/react/24/solid";
import React, { FC, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ModalSubcription from "./ModalSubcription";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import { UserState } from "containers/PageLogin/PageLogin";
import Notify from "components/Notify";
import { toast } from "react-hot-toast";
export interface PageSubcriptionProps {
  className?: string;
}

export interface PricingItem {
  isPopular: boolean;
  name: string;
  pricing: number;
  desc: string;
  per: string;
  features: string[];
  plan: number
}

const pricings: PricingItem[] = [
    
  {
    plan: 1,
    isPopular: true,
    name: "Démarrage",
    pricing: 5000,
    per: "/an",
    features: [
      "Publier jusqu'à 50 produits",
      "25 boosts offert",
      "Un ADS gratuit pour une journné",
      "Une remise de 5% sur les boosts",
    ],
    desc: ``,
  },
  {
    plan: 2,
    isPopular: false,
    name: "Basique",
    pricing: 10000,
    per: "/an",
    features: [
      "Publier jusqu'à 100 produits",
      "50 boosts offert",
      "Un ADS gratuit pour une 2 jours",
      "Une remise de 10% sur les boosts",
    ],
    desc: ``,
  },
  {
    plan: 3,
    isPopular: false,
    name: "Professionnelle",
    pricing: 30000,
    per: "/an",
    features: [
      "Publier jusqu'à 500 produits",
      "150 boosts offert",
      "Un ADS gratuit pour une 4 jours",
      "Une remise de 20% sur les boosts",
    ],
    desc: ``,
  },
];

const PageSubcription: FC<PageSubcriptionProps> = ({ className = "" }) => {
  const userLogin = useSelector<RootState, UserState>( (state: RootState) => state.authorizationReducer )
  const {loggedIn} = userLogin
  const { t } = useTranslation();
  const [showModalSubcription, setShowModalSubcription] = React.useState(false);
  const [modalData, setModaldata] = useState<PricingItem>(pricings[0]);
  const navigate = useNavigate();
  const onClickHandeler = (data: PricingItem) => {
    setModaldata(data)
    
    if(!loggedIn){
      toast.custom((t) => (
        <Notify 
            t={t}
            message="Vous devez etre connecté pour pouvoir souscrire!"
            status ='warning'
        />),
        { position: "top-right", id: "nc-product-notify", duration: 3000 }
      )
      navigate("/login");
    }
    
    else
      setShowModalSubcription(true)
  }
  const renderPricingItem = (pricing: PricingItem, index: number) => {
    return (
      <div
        key={index}
        className={`h-full relative px-6 py-8 rounded-3xl border-2 flex flex-col overflow-hidden ${
          pricing.isPopular
            ? "border-primary-500"
            : "border-neutral-100 dark:border-neutral-700"
        }`}
      >
        {pricing.isPopular && (
          <span className="bg-primary-500 text-white px-3 py-1 tracking-widest text-xs absolute right-3 top-3 rounded-full z-10">
            POPULAR
          </span>
        )}
        <div className="mb-8">
          <h3 className="block text-sm uppercase tracking-widest text-neutral-6000 dark:text-neutral-300 mb-2 font-medium">
            {pricing.name}
          </h3>
          <h2 className="text-5xl leading-none flex items-center text-slate-800 dark:text-slate-200">
            <span>{pricing.pricing}DA</span>
            <span className="text-lg ml-1 font-normal text-neutral-500">
              {pricing.per}
            </span>
          </h2>
        </div>
        <nav className="space-y-4 mb-8">
          {pricing.features.map((item, index) => (
            <li className="flex items-center" key={index}>
              <span className="mr-4 inline-flex flex-shrink-0 text-primary-6000">
                <CheckIcon className="w-5 h-5" aria-hidden="true" />
              </span>
              <span className="text-neutral-700 dark:text-neutral-300">
                {item}
              </span>
            </li>
          ))}
        </nav>
        <div className="flex flex-col mt-auto">
        {/* className="cursor-not-allowed" */}
          {pricing.isPopular ? (
            <ButtonPrimary onClick={() => onClickHandeler(pricing)}>Choisir</ButtonPrimary>
          ) : (
            <ButtonSecondary onClick={() => onClickHandeler(pricing)}>
              <span className="font-medium">{t('Choisir')}</span>
            </ButtonSecondary>
          )}
          <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-3">
            {pricing.desc}
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
      className={`nc-PageSubcription container pb-24 lg:pb-32 ${className}`}
      data-nc-id="PageSubcription"
    >
      <header className="text-center max-w-2xl mx-auto my-20">
        <h2 className="flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          <span className="mr-4 text-3xl md:text-4xl leading-none">💎</span>
          Abonnement
        </h2>
        <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
          Des prix adaptés à vos besoins.
        </span>
      </header>
      <section className="text-neutral-600 text-sm md:text-base overflow-hidden">
        <div className="grid lg:grid-cols-3 gap-5 xl:gap-8">
          {pricings.map(renderPricingItem)}
        </div>
      </section>
    </div>
    <ModalSubcription
    data={modalData}
    show={showModalSubcription}
    onCloseModalSubcription={() => setShowModalSubcription(false)}
     />

 
    </>

  );
};

export default PageSubcription;
